import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/www/src/components/mdx/index.tsx";
import { graphql } from 'gatsby';
import { ComponentHeader } from 'components/thumbprint-components';
export const pageQuery = graphql`
    {
        # Get links to by path to display in the navbar.
        platformNav: allSitePage(filter: { path: { glob: "/components/shadow-card/*/" } }) {
            edges {
                node {
                    ...PlatformNavFragment
                }
            }
        }
    }
`;
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  pageQuery,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <ComponentHeader data={props.data} mdxType="ComponentHeader" />
    <h2>{`Summary`}</h2>
    <p>{`This control is a `}<inlineCode parentName="p">{`View`}</inlineCode>{` with a default appearance and a highlighted appearance. Also provides a tap action handler.`}</p>
    <h2>{`Example 1`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`TPShadowCard(action: {
    // Some action
    self.title = "Hellow Shadow Card!"
}, content: {
    Text(title)
})
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/img/swiftui/shadow-card/shadow-card-1.png",
        "alt": "Default"
      }}></img></p>
    <h2>{`Example 2`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`TPShadowCard(padding: .space16, action: {
    // Some action
    self.bodyText = "This is something is really awesome!"
}, content: {
    VStack(alignment: .leading) {
        Text("Heading")
            .tpFontStyle(.title1)
            .padding(EdgeInsets(top: 0, leading: 0, bottom: .space4, trailing: 0))
        Text(bodyText)
        Spacer(minLength: .space24)
        TPButton(title: "Cool!") {
            // Button action
            self.bodyText = "This is something is really cool!"
        }
    }
    .frame(maxWidth: .infinity, alignment: .leading)
    .fixedSize(horizontal: false, vertical: true)
})
`}</code></pre>
    <p><img parentName="p" {...{
        "src": "/img/swiftui/shadow-card/shadow-card-2.png",
        "alt": "Default"
      }}></img></p>
    <h2>{`Constructor`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`
TPShadowCard(
    shadow: TPShadow = .shadow300,
    backgroundColor: Color = .tpWhite,
    highlightedColor: Color = .tpGray300,
    padding: CGFloat = .space8,
    cornerRadius: CGFloat = .space4,
    shouldHighlight: Bool = true,
    action: (() -> Void)? = nil,
    @ViewBuilder content: @escaping () -> Content
)
`}</code></pre>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      